/**
 * A minimal registry that lets TrainingSpringContentStepTwo expose its
 * "open save-template dialog" callback to FlowBottomComponentWrapper without
 * prop-drilling through the FlowContainer infrastructure.
 *
 * Only one sprint-creation wizard is ever mounted at a time, so a single
 * mutable slot is sufficient.
 */

type OpenSaveTemplateDialog = () => void

let registeredCallback: OpenSaveTemplateDialog | null = null

export function registerSaveTemplateCallback(cb: OpenSaveTemplateDialog): void {
  registeredCallback = cb
}

export function unregisterSaveTemplateCallback(): void {
  registeredCallback = null
}

export function invokeSaveTemplateCallback(): void {
  registeredCallback?.()
}
